import React, { ComponentPropsWithoutRef } from "react";
import PillarForm from "shared/components/pillar-form/PillarForm";
import { PillarTableBaseColumnProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import PillarTable from "shared/components/pillar-table/PillarTable";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";

export type PillarTableBooleanIconType = React.ReactElement<
  React.SVGProps<SVGSVGElement> & {
    className?: string;
    title?: string;
  }
>;
export type PillarTableColumnButtonProps<T> = {
  onClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    rowValue: T,
  ) => void;
} & PillarTableBaseColumnProps<T> &
  Omit<ComponentPropsWithoutRef<"button">, "onClick">;

const PillarTableColumnButton = <T extends object = any>({
  onClick,
  children,
  ...props
}: PillarTableColumnButtonProps<T>) => {
  const { rowValue } = usePillarTableRowContext<T>();
  return (
    <PillarForm.Button
      className="button-small-general-filled"
      testid={props.testid}
      onClick={(event) => {
        onClick?.(event, rowValue);
      }}
    >
      {children}
    </PillarForm.Button>
  );
};
PillarTableColumnButton.doNotExport = true;
export default PillarTableColumnButton;
